// Tork SEO — single source for the trial CTA.
// Points at the existing "$1 trial" signup flow used elsewhere on the site
// (/trial → TrialLanding → AuthPage with $1-trial copy + lead-source tracking).
export const TRIAL_HREF = "/trial";
export const TRIAL_LABEL = "Start your $1 trial";
export const RISK_REVERSAL = "10x the value or cancel in one click — you risk $1.";

// Trust signals shown in the <TrustBar> on every page (owner-verified facts).
export const TRUST_ITEMS = [
  "5,000+ businesses helped rank",
  "35+ years of combined local marketing experience",
  "Built from a $10K/mo Google Maps Domination service",
];

export const SITE_ORIGIN = "https://tork.digitaldomination.ai";
